import { SENDING_LOCATOR, UPDATE_LOCATOR, SET_LOCATOR_ERRORS } from '../../../types/conversations/plugins'
import apiConversation from 'api/conversation'

const locatorPluginApi = apiConversation.plugins.locators

const sendingLocator = (userId, sendingLocator = true) => ({
  userId,
  sendingLocator,
  type: SENDING_LOCATOR,
})
const updateLocator = (userId, locator) => (dispatch) => dispatch({ userId, locator, type: UPDATE_LOCATOR })
const setLocatorErrors = (userId, errors = {}) => ({ userId, errors, type: SET_LOCATOR_ERRORS })

const sendLocator = ({ user, locator }) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(sendingLocator(user.id))
    dispatch(setLocatorErrors(user.id))

    const { airlines, locators, type, locatorBooking } = locator

    locatorPluginApi
      .sendLocator({ user, airlines, locators, locatorBooking, type })
      .then(({ data, status }) => {
        //  dispatch(sendingLocator(user.id, false));

        if (status !== 200) return dispatch(setLocatorErrors(user.id, data))

        resolve()
      })
      .catch((error) => {
        console.error('sendLocator -> error', error)
        dispatch(setLocatorErrors(user.id, { error: 'server-error' }))
        reject()
      })
  })
}

export default { sendLocator, updateLocator }
